import React, { Component } from "react";
// import { Redirect } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { css } from "react-emotion";
import API from "@aws-amplify/api";
import aws_exports from "../../aws-exports";
import Amplify from "aws-amplify";
import { connect } from "react-redux";
import Header from "../../common/header";
import Footer from "../../common/footer";
Amplify.configure(aws_exports);

let apiName = "preferencecenter";
let path = "/users";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;


class ResidentialForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      firstnameError: false,
      lastname: "",
      lastnameError: false,
      address: "",
      addressError: false,
      city: "",
      cityError: false,
      state: "",
      stateError: false,
      zip: "",
      zipError: false,
      phone: "",
      phoneError: false,
      email: "",
      emailError: false,
      submit: false,
      data: "",
      bill: "",
      mKey: "",
      notification: false,
      loading: false,
      redirect: false,
      newRecord: false
    };
  }
  handleChange(event, type) {
    this.setState({
      [event.target.id]: event.target.value
    });
    switch (type) {
      case "firstname":
        if (event.target.value === "") {
          this.setState({ firstnameError: true });
        } else {
          this.setState({ firstnameError: false });
        }
        break;
      case "lastname":
        if (event.target.value === "") {
          this.setState({ lastnameError: true });
        } else {
          this.setState({ lastnameError: false });
        }
        break;
      // case "phone":
      //   if (event.target.value !== "") {
      //     this.setState({ phoneError: true });
      //   } else {
      //     this.setState({ phoneError: false });
      //   }
      //   break;
      // case "email":
      //   if (event.target.value === "") {
      //     this.setState({ emailError: true });
      //   } else {
      //     this.setState({ emailError: false });
      //   }
      //   break;
      case "address":
        if (event.target.value === "") {
          this.setState({ addressError: true });
        } else {
          this.setState({ addressError: false });
        }
        break;
      case "city":
        if (event.target.value === "") {
          this.setState({ cityError: true });
        } else {
          this.setState({ cityError: false });
        }
        break;
      case "state":
        if (event.target.value === "") {
          this.setState({ stateError: true });
        } else {
          this.setState({ stateError: false });
        }
        break;
      case "zip":
        if (event.target.value === "") {
          this.setState({ zipError: true });
        } else {
          this.setState({ zipError: false });
        }
        break;

      default:
        break;
    }
  }
  handleSubmit = async event => {
    event.preventDefault();
    const zipRex = /^\d{5}(?:[-\s]\d{4})?$/;
    const phoneRex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.state.email === "") {
      this.setState({ emailError: false });
    }
    if (this.state.phone === "") {
      this.setState({ phoneError: false });
    }
    if (
      this.state.firstname === "" ||
      this.state.lastname === "" ||
      this.state.address === "" ||
      this.state.city === "" ||
      this.state.state === "" ||
      this.state.zip === "" ||
      (this.state.zip !== "" && !this.state.zip.match(zipRex)) ||
      (this.state.phone !== "" && !this.state.phone.match(phoneRex)) ||
      (this.state.email !== "" && !this.state.email.match(emailRex))
    ) {
      if (this.state.firstname === "") {
        this.setState({
          firstnameError: true
        });
      }
      if (this.state.lastname === "") {
        this.setState({
          lastnameError: true
        });
      }
      if (this.state.address === "") {
        this.setState({
          addressError: true
        });
      }
      if (this.state.city === "") {
        this.setState({
          cityError: true
        });
      }
      if (this.state.state === "") {
        this.setState({
          stateError: true
        });
      }
      if (
        this.state.zip === "" ||
        (this.state.zip !== "" && !this.state.zip.match(zipRex))
      ) {
        this.setState({
          zipError: true
        });
      }
      if (this.state.phone !== "" && !this.state.phone.match(phoneRex)) {
        this.setState({
          phoneError: true
        });
      } else {
        this.setState({
          phoneError: false
        });
      }
      if (this.state.email !== "" && !this.state.email.match(emailRex)) {
        this.setState({
          emailError: true
        });
      }
    } else if (
      !this.state.firstnameError &&
      !this.state.lastnameError &&
      !this.state.addressError &&
      !this.state.cityError &&
      !this.state.stateError &&
      !this.state.zipError &&
      !this.state.phoneError &&
      !this.state.emailError
    ) {
      this.setState({
        submit: true,
        loading: true,
        email: this.state.email,
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        address: this.state.address,
        city: this.state.city
        // phone: this.state.phone.toLowerCase()
      });
      this.checkMkey();
    }
  };

  checkMkey = () => {
    // console.log("checkMkey")
    let myInit1 = {
      headers: {
        nameLast: this.state.lastname.toUpperCase(),
        address: this.state.address.toUpperCase(),
        zip: this.state.zip
      }
    };
    API.get(apiName, "/checkMkey", myInit1).then(response => {
      // console.log(response);
      if (response.length > 0) {
        this.setState({ mKey: response });
        let myInit2 = {
          headers: {
            mKey: response,
            accountType: "res"
          }
        };
        API.get(apiName, path, myInit2).then(response => {
          // console.log(response);
          if (response.length > 0) {
            // console.log(response[0].accounts)
            if(response[0].accounts === undefined) {
              localStorage.setItem("ref", "");
              localStorage.setItem("mKey", response[0].mKey);
              localStorage.setItem(
                "nameLast",
                response[0]["contact"]["nameLast"]
              );
              localStorage.setItem("uniqueKey", response[0].uniqueKey);
              localStorage.setItem(
                "nameFirst",
                response[0]["contact"]["nameFirst"]
              );
              localStorage.setItem(
                "lastModifiedDate",
                response[0].lastModifiedDate
              );
              localStorage.setItem("classification", response[0].classification);
              localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
              localStorage.setItem(
                "state",
                response[0]["serviceAddress"]["state"]
              );
              localStorage.setItem(
                "smsGlobal",
                response[0]["preferences"]["global"]["sms"]["status"]
              );
              localStorage.setItem(
                "emailNewstips",
                response[0]["preferences"]["newsTips"]["email"]["status"]
              );
              localStorage.setItem(
                "mailNewstips",
                response[0]["preferences"]["newsTips"]["mail"]["status"]
              );
              this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
              this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
              this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
              
              this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });
              
              if (response[0].classification === "DIRECT") {
                this.setState({ bill: "CONSTELLATION_ENERGY" });
              } else if (response[0].classification === "UTILITY") {
                this.setState({ bill: "CONSTELLATION_UTILITY_BILLED" });
              }
              this.setState({ data: response, redirect: true, loading: false });
            } else {
              this.setState({ loading: false });
              window.$('#newRecord').modal('show');
            }
          } else if (this.state.phone !== "") {
            this.checkPhone();
          } else if (this.state.email !== "") {
            this.checkEmail();
          } else {
            this.setState({ loading: false });
            window.$('#newRecord').modal('show');
            // this.insertQuery();
          }
        });
      }
    });
  };

  checkPhone() {
    let myInit1 = {
      headers: {
        phone: this.state.phone,
        accountType: "res"
      }
    };
    // console.log("in checkPhone");
    API.get(apiName, path, myInit1).then(response => {
      // console.log(response);
      if (response.length > 0) {
        localStorage.setItem("ref", "");
        localStorage.setItem("mKey", response[0].mKey);
        localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
        localStorage.setItem("uniqueKey", response[0].uniqueKey);
        localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
        localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
       
        localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
        localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
        localStorage.setItem(
          "smsGlobal",
          response[0]["preferences"]["global"]["sms"]["status"]
        );
        localStorage.setItem(
          "emailNewstips",
          response[0]["preferences"]["newsTips"]["email"]["status"]
        );
        localStorage.setItem(
          "mailNewstips",
          response[0]["preferences"]["newsTips"]["mail"]["status"]
        );
        localStorage.setItem("classification", response[0].classification);
        this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
            
        this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
            
        this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });

        this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
        
        if (response[0].classification === "DIRECT") {
          this.setState({ bill: "CONSTELLATION_ENERGY" });
        } else if (response[0].classification === "UTILITY") {
          this.setState({ bill: "CONSTELLATION_UTILITY_BILLED" });
        }
        this.setState({ data: response, redirect: true, loading: false });
      } else if (this.state.email !== "") {
        this.checkEmail();
      } else if (this.state.email === "") {
        this.setState({ loading: false });
        window.$('#newRecord').modal('show');
        // this.insertQuery();
      }
    });
  }

  checkEmail() {
    let myInit1 = {
      headers: {
        email: this.state.email.toLowerCase(),
        accountType: "res"
      }
    };
    // console.log("in checkEmail");
    API.get(apiName, path, myInit1).then(response => {
      // console.log(response);
      if (response.length > 0) {
        localStorage.setItem("ref", "");
        localStorage.setItem("mKey", response[0].mKey);
        localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
        localStorage.setItem("uniqueKey", response[0].uniqueKey);
        localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
        localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
        
        localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
        localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
        localStorage.setItem(
          "smsGlobal",
          response[0]["preferences"]["global"]["sms"]["status"]
        );
        localStorage.setItem(
          "emailNewstips",
          response[0]["preferences"]["newsTips"]["email"]["status"]
        );
        localStorage.setItem(
          "mailNewstips",
          response[0]["preferences"]["newsTips"]["mail"]["status"]
        );
        localStorage.setItem("classification", response[0].classification);
        this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
        this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
        this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
            
        this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });
        
        if (response[0].classification === "DIRECT") {
          this.setState({ bill: "CONSTELLATION_ENERGY" });
        } else if (response[0].classification === "UTILITY") {
          this.setState({ bill: "CONSTELLATION_UTILITY_BILLED" });
        }
        this.setState({ data: response, redirect: true, loading: false });
      } else if (this.state.email !== "") {
        this.setState({ loading: false });
        window.$('#newRecord').modal('show');
      }
    });
  }

  insertQuery = () => {
    // console.log("create")
    const uuidv4 = require("uuid/v4");
    let uuid = uuidv4();
    this.setState({ lastModifiedDate: new Date().toJSON() });
    let myInit2 = {
      body: {
        uniqueKey: uuid,
        referenceId: uuid.substring(0,8).toLowerCase(),
        mKey: this.state.mKey,
        contact: {
          nameFirst: this.state.firstname.toUpperCase(),
          nameLast: this.state.lastname.toUpperCase(),
          updated: this.state.lastModifiedDate
        },
        serviceAddress: {
          address: this.state.address.toUpperCase(),
          city: this.state.city.toUpperCase(),
          state: this.state.state,
          zip: this.state.zip,
          updated: this.state.lastModifiedDate
        },
        lastModifiedDate: this.state.lastModifiedDate,
        classification: "UTILITY",
        preferences: {
          global: {
            sms: { status: "0", updated: this.state.lastModifiedDate }
          },
          newsTips: {
            email: { status: "0", updated: this.state.lastModifiedDate },
            mail: { status: "0", updated: this.state.lastModifiedDate }
          }
        }
      }
    };
    if (this.state.email !== "") {
      myInit2['body']['email'] = this.state.email.toLowerCase()
    }
    if (this.state.phone !== "") {
      myInit2['body']['phone'] = this.state.phone
    }
    // console.log(myInit2);
    // console.log("in insertQuery");
    API.post(apiName, path, myInit2)
      .then(response => {
        // console.log(response);
        localStorage.setItem("uniqueKey", response["uniqueKey"]);
        localStorage.setItem("ref", "");
        localStorage.setItem("mKey", this.state.mKey);
        localStorage.setItem("nameFirst", this.state.firstname);
        localStorage.setItem("nameLast", this.state.lastname);
        localStorage.setItem("lastModifiedDate", this.state.lastModifiedDate);
        localStorage.setItem("city", this.state.city);
        localStorage.setItem("state", this.state.state);
        localStorage.setItem("smsGlobal", "0");
        localStorage.setItem("emailNewstips", "0");
        localStorage.setItem("mailNewstips", "0");
        localStorage.setItem("classification", "UTILITY");
        this.props.dispatch({ type: "ADD_PHONE", payload: this.state.phone === "" ? "-" : this.state.phone });
        this.props.dispatch({ type: "ADD_EMAIL", payload: this.state.email === "" ? "-" : this.state.email });
        this.props.dispatch({ type: "ADD_ZIP", payload: this.state.zip === "" ? "-" : this.state.zip });
        this.props.dispatch({ type: "ADD_STREET", payload: this.state.address === "" ? "-" : this.state.address });
        
        this.setState({redirect: true, loading: false, bill: "CONSTELLATION_UTILITY_BILLED"});
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    if (this.state.submit) {
      // console.log("submit");
      if (this.state.address !== "") {
        // this.checkMkey();
      }
      // this.setState({ submit: false });
    }
    if (this.state.redirect) {
      // console.log(this.state.bill);
      this.props.history.push({
        pathname: "/update",
        search: "?ProgramGroupID=" + this.state.bill
      });
    }
    return (
      <React.Fragment>
      <Header/>
      <main className="locateprefs">
        <div className="container loginFont">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-6 loginForm">
              <h3 className="text-left " style={{ color: "#81CFE7", fontWeight: "bold" }}>Locate My Preferences</h3>
              <form
                id="login-form"
                className="form-horizontal"
                onSubmit={this.handleSubmit}
                style={{ padding: "7px" }}
              >
                <br />
                <div className="form-grid">
                  <div className="form-grid-label">  <label className="control-label">
                        First Name*{" "}
                      </label>
                      </div>
                    <div className="formInput">
                      <input
                        className="form-control loginInput pull-center "
                        id="firstname"
                        name="firstname"
                        type="text"
                        onChange={event =>
                          this.handleChange(event, "firstname")
                        }
                        value={this.state.firstname}
                      />

                      <div
                      className={
                        this.state.firstnameError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid firstname.
                    </div>
                    </div>
               

                    <div className="form-grid-label">
                    <label className="control-label">
                        Last Name*{" "}
                      </label>
                    </div>

                    <div className="formInput ">
                      <input
                        className="form-control loginInput"
                        id="lastname"
                        name="lastname"
                        type="text"
                        onChange={event => this.handleChange(event, "lastname")}
                        value={this.state.lastname}
                      />

            <div
                      className={
                        this.state.lastnameError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid lastname.
                    </div>
                    </div>
              

                    <div className="form-grid-label">
                    <label className="control-label">
                        Service Address*{" "}
                      </label>
                    </div>

                    <div className="formInput">
                      <input
                        className="form-control loginInput pull-center "
                        id="address"
                        name="ContactElementInfo.Address"
                        type="text"
                        onChange={event => this.handleChange(event, "address")}
                        value={this.state.address}
                      />

                  <div
                      className={
                        this.state.addressError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid address.
                    </div>
                    </div>
                 

                    <div className="form-grid-label">
                    <label className="control-label" style={{width: "auto"}}>City* </label>

                    </div>

                    {/* <div className="formInput row-city"> */}
                      <div className="sub-grid-city">
                      <input
                        className="form-control loginInput"
                        id="city"
                        name="ContactElementInfo.City"
                        type="text"
                        onChange={event => this.handleChange(event, "city")}
                        value={this.state.city}
                      />
                           <div
                      className={
                        this.state.cityError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid city.
                    </div> 
                      </div>
                      
                     
                      {/* </div> */}
    
                      {/* <div class="form-grid-label">
                       <label className="control-label" locateState>
                        State*{" "}
                      </label>
                      <select
                        className="form-control loginInput"
                        id="state"
                        name="ContactElementInfo.State"
                        onChange={event => this.handleChange(event, "state")}
                        value={this.state.state}
                      >
                      <option value="">Select State</option>
                        <option value="AL">AL</option>
                        <option value="AK">AK</option>
                        <option value="AZ">AZ</option>
                        <option value="AR">AR</option>
                        <option value="CA">CA</option>
                        <option value="CO">CO</option>
                        <option value="CT">CT</option>
                        <option value="DE">DE</option>
                        <option value="DC">DC</option>
                        <option value="FL">FL</option>
                        <option value="GA">GA</option>
                        <option value="HI">HI</option>
                        <option value="ID">ID</option>
                        <option value="IL">IL</option>
                        <option value="IN">IN</option>
                        <option value="IA">IA</option>
                        <option value="KS">KS</option>
                        <option value="KY">KY</option>
                        <option value="LA">LA</option>
                        <option value="ME">ME</option>
                        <option value="MD">MD</option>
                        <option value="MA">MA</option>
                        <option value="MI">MI</option>
                        <option value="MN">MN</option>
                        <option value="MS">MS</option>
                        <option value="MO">MO</option>
                        <option value="MT">MT</option>
                        <option value="NE">NE</option>
                        <option value="NV">NV</option>
                        <option value="NH">NH</option>
                        <option value="NJ">NJ</option>
                        <option value="NM">NM</option>
                        <option value="NY">NY</option>
                        <option value="NC">NC</option>
                        <option value="ND">ND</option>
                        <option value="OH">OH</option>
                        <option value="OK">OK</option>
                        <option value="OR">OR</option>
                        <option value="PA">PA</option>
                        <option value="RI">RI</option>
                        <option value="SC">SC</option>
                        <option value="SD">SD</option>
                        <option value="TN">TN</option>
                        <option value="TX">TX</option>
                        <option value="UT">UT</option>
                        <option value="VT">VT</option>
                        <option value="VA">VA</option>
                        <option value="WA">WA</option>
                        <option value="WV">WV</option>
                        <option value="WI">WI</option>
                        <option value="WY">WY</option>
                      </select>
                      <div
                      className={
                        this.state.stateError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid state.
                    </div>
                      </div> */}

                  <div className="form-grid-label">
                    <label className="control-label locateState">
                        State*{" "}
                      </label>
                    </div>
                    <div className="formInput">
                    <select
                        className="form-control loginInput"
                        id="state"
                        name="ContactElementInfo.State"
                        onChange={event => this.handleChange(event, "state")}
                        value={this.state.state}
                      >
                        <option value="">Select State</option>
                        <option value="AL">AL</option>
                        <option value="AK">AK</option>
                        <option value="AZ">AZ</option>
                        <option value="AR">AR</option>
                        <option value="CA">CA</option>
                        <option value="CO">CO</option>
                        <option value="CT">CT</option>
                        <option value="DE">DE</option>
                        <option value="DC">DC</option>
                        <option value="FL">FL</option>
                        <option value="GA">GA</option>
                        <option value="HI">HI</option>
                        <option value="ID">ID</option>
                        <option value="IL">IL</option>
                        <option value="IN">IN</option>
                        <option value="IA">IA</option>
                        <option value="KS">KS</option>
                        <option value="KY">KY</option>
                        <option value="LA">LA</option>
                        <option value="ME">ME</option>
                        <option value="MD">MD</option>
                        <option value="MA">MA</option>
                        <option value="MI">MI</option>
                        <option value="MN">MN</option>
                        <option value="MS">MS</option>
                        <option value="MO">MO</option>
                        <option value="MT">MT</option>
                        <option value="NE">NE</option>
                        <option value="NV">NV</option>
                        <option value="NH">NH</option>
                        <option value="NJ">NJ</option>
                        <option value="NM">NM</option>
                        <option value="NY">NY</option>
                        <option value="NC">NC</option>
                        <option value="ND">ND</option>
                        <option value="OH">OH</option>
                        <option value="OK">OK</option>
                        <option value="OR">OR</option>
                        <option value="PA">PA</option>
                        <option value="RI">RI</option>
                        <option value="SC">SC</option>
                        <option value="SD">SD</option>
                        <option value="TN">TN</option>
                        <option value="TX">TX</option>
                        <option value="UT">UT</option>
                        <option value="VT">VT</option>
                        <option value="VA">VA</option>
                        <option value="WA">WA</option>
                        <option value="WV">WV</option>
                        <option value="WI">WI</option>
                        <option value="WY">WY</option>
                      </select>
                       <div
                      className={
                        this.state.stateError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid State.
                    </div>
                    </div>

                    <div className="form-grid-label">
                    <label className="control-label locateZip">
                        ZipCode*{" "}
                      </label>
                    </div>
                    <div className="formInput">
                      <input
                        className="form-control loginInput"
                        id="zip"
                        name="ContactElementInfo.Mail"
                        type="text"
                        onChange={event => this.handleChange(event, "zip")}
                        value={this.state.zip}
                      />
                            <div
                      className={
                        this.state.zipError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid zip.
                    </div>
                    </div>
              

                    <div className="form-grid-label">
                      <label className="control-label">Phone: </label>
                    </div>

                    <div className="formInput">
                      <input
                        className="form-control loginInput"
                        id="phone"
                        name="ContactElementInfo.Phone"
                        type="text"
                        onChange={event => this.handleChange(event, "phone")}
                        value={this.state.phone}
                      />

<div
                      className={
                        this.state.phoneError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid phone.
                    </div>
                    </div>
                  

                    <div className="form-grid-label">
                    <label className="control-label">Email: </label>
                    </div>

                    <div className="formInput">
                      <input
                        className="form-control loginInput"
                        id="email"
                        name="ContactElementInfo.Email"
                        type="text"
                        onChange={event => this.handleChange(event, "email")}
                        value={this.state.email}
                      />

<div
                      className={
                        this.state.emailError
                          ? "error fontSmall"
                          : "hidden"
                      }
                    >
                      Please provide a valid email.
                    </div>
                    </div>
                  
                  
                </div>
                <div className="form-group text-center">
                  <br />
                  <button
                    style={{ minWidth: "100px" }}
                    type="submit"
                    name="submit"
                    className={this.state.loading ? "hidden" : "btn button"}
                    id="search"
                    
                  >
                    Search
                  </button>
                  <div
                    className={this.state.loading ? "sweet-loading" : "hidden"}
                  >
                    <ScaleLoader
                      className={override}
                      sizeUnit={"px"}
                      size={20}
                      color={"rgb(244, 123, 39)"}
                      loading={this.state.loading}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div
            className="modal fade"
            id="newRecord"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="newRecordTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h5
                    className="modal-title text-center fontLarge"
                    id="newRecordTitle"
                  >
                   { /*Create New Record */}
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body fontMedium text-justify">
                  <p className="text-center">
                  No record found with the information provided.
                  </p>
                  <p className="text-center">
                    {/* Please click the link below to contact our Constellation Customer Care team for further assistance at (877) 677-4355 */}
                    Please <a href="https://www.constellation.com/about-us/contact-us.html">contact us</a> for further assistance.
                  </p>
                  {/* <p className="text-center">
                    Do you like to create a new record?
                  </p> */}
                </div>
                <div className="modal-footer">
                  <div className=" col-12 text-center">
                    <button
                      type="button"
                      className="disagreeButton"
                      data-dismiss="modal"
                      style={{ marginRight: "10px", marginBottom: "10px" }}
                    >
                      CANCEL
                    </button>
                   {/*  <button
                      type="button"
                      className="modalButton"
                      style={{ marginBottom: "10px" }}
                      onClick={this.insertQuery}
                      data-dismiss="modal"
                    >
                      CREATE
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer/>
      </React.Fragment>
    );
  }
}


const mapStateToProps = state => ({
  reduxEmail: state.reduxEmail,
  reduxPhone: state.reduxPhone,
  reduxStreet: state.reduxStreet,
  reduxZip: state.reduxZip
});

export default connect(mapStateToProps)(ResidentialForm);



// WEBPACK FOOTER //
// ./src/views/CustomerPages/ResidentialForm.jsx